import React, { useState } from 'react';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Text } from '@uhg-abyss/web/ui/Text';
import { SuggestProgramType } from '@src/api.types';
import { SuggestProgramEditModal } from './SuggestProgramEditModal';

export type SuggestProgramProps = {
  originalProgramData: SuggestProgramType;
  onUpdateProgram: (program: SuggestProgramType) => void;
  onDeleteProgram: (program: SuggestProgramType) => void;
};

export const SuggestProgram = ({
  originalProgramData,
  onUpdateProgram,
  onDeleteProgram,
}: SuggestProgramProps) => {
  const [isEditProgram, setIsEditProgram] = useState(false);
  const [programData, setProgramData] =
    useState<SuggestProgramType>(originalProgramData);

  const edit = (programData: SuggestProgramType) => {
    setIsEditProgram(true);
  };
  const onDelete = (programData: SuggestProgramType) => {
    onDeleteProgram(programData);
  };
  const fieldStyle = {
    paddingTop: '1px',
    paddingBottom: '1px',
    marginBottom: '35px',
    height: '100px',
    overflow: 'auto',
  };

  return (
    <Flex
      data-cy="suggest-program"
      direction="column"
      justify="start"
      style={{
        marginTop: '5px',
        marginBottom: '5px',
        marginLeft: '5px',
        padding: '15px',
        border: 'solid #D3D3D3 1px',
        borderRadius: '10px',
      }}
    >
      <Grid>
        <Grid.Col span={{ xs: 12, md: 4, lg: 4 }}>
          <div style={fieldStyle}>
            <Text fontWeight="bold">Provider/CBO Name</Text>
            <div>{programData?.providerCBOName}</div>
          </div>
          <div style={fieldStyle}>
            <Text fontWeight="bold">Program Website</Text>
            <div>{programData?.programWebsite}</div>
          </div>
        </Grid.Col>
        <Grid.Col span={{ xs: 12, md: 6, lg: 4 }}>
          <div style={fieldStyle}>
            <Text fontWeight="bold">Program Name and Description</Text>
            <div>{programData?.programName}</div>
          </div>
          <div style={fieldStyle}>
            <Text fontWeight="bold">State Code</Text>
            <div>{programData?.stateCode}</div>
          </div>
          <div style={fieldStyle}>
            <Text fontWeight="bold">Submitter Email</Text>
            <div>{programData?.advocateEmail}</div>
          </div>
        </Grid.Col>
        <Grid.Col span={{ xs: 12, md: 4, lg: 4 }}>
          <div style={fieldStyle}>
            <Text fontWeight="bold">Program Phone</Text>
            <div>{programData?.programPhone}</div>
          </div>
          <div style={fieldStyle}>
            <Text fontWeight="bold">Notes</Text>
            <div>{programData?.notes}</div>
          </div>
        </Grid.Col>
      </Grid>
      <div>
        <Button
          data-cy="edit-program"
          variant="outline"
          style={{ width: '20%', float: 'left', margin: '10px' }}
          onClick={() => {
            edit(programData);
          }}
        >
          Edit
        </Button>
        <Button
          data-cy="remove-program"
          variant="text"
          color="brand"
          style={{ width: '20%', float: 'left', margin: '10px' }}
          onClick={() => {
            onDelete(programData);
          }}
        >
          Remove
        </Button>
      </div>
      <SuggestProgramEditModal
        programData={programData}
        isOpen={isEditProgram}
        setIsOpen={setIsEditProgram}
        onSaveProgram={(program) => {
          setProgramData(program);
          onUpdateProgram(program);
        }}
        listOfValidFields={[
          'providerName',
          'programName',
          'phoneWebsite',
          'stateCode',
        ]}
      />
    </Flex>
  );
};
